import AbstractStonecodeFileServiceModel from './AbstractStonecodeFileServiceModel';

export default class StonecodeFileServiceModel extends AbstractStonecodeFileServiceModel {
}
